import { render } from "./AdminLayout.vue?vue&type=template&id=bafdabb6"
import script from "./AdminLayout.vue?vue&type=script&lang=js"
export * from "./AdminLayout.vue?vue&type=script&lang=js"

import "./AdminLayout.vue?vue&type=style&index=0&id=bafdabb6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/layouts/AdminLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bafdabb6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bafdabb6', __exports__)) {
    api.reload('bafdabb6', __exports__)
  }
  
  module.hot.accept("./AdminLayout.vue?vue&type=template&id=bafdabb6", () => {
    api.rerender('bafdabb6', render)
  })

}


export default __exports__